import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { StatusIncident } from '@portal-core/status-incidents/models/status-incident.model';

@CollectionStateSelectors({
  stateType: StatusIncidentsState
})
@State<StatusIncidentsState>({
  name: StatusIncidentsState.source
})
@Service({ autoProvided: false })
export class StatusIncidentsState extends CollectionStateBase {
  static override source: string = 'StatusIncidents';

  getSource(): string {
    return StatusIncidentsState.source;
  }
}

@Service()
export class StatusIncidentsDataService extends CollectionDataServiceBase<StatusIncident> {
  protected readonly stateType = StatusIncidentsState;
}
